import { IconImage } from '@procurify/ui'

import { useFormatMedia } from '@webapp/core/hooks/useFormatMedia'
import { ConversationOrderSummaryThumbnailStyled } from './styles/ConversationOrderSummaryThumbnailStyled'
import { useFailedImages } from '../../hooks/useFailedImages'

export interface IConversationOrderSummaryThumbnailProps {
  img?: string
}

export const ConversationOrderSummaryThumbnail = ({
  img,
}: IConversationOrderSummaryThumbnailProps) => {
  const formatMedia = useFormatMedia()
  const { hasFailed, markFailed } = useFailedImages()

  return (
    <ConversationOrderSummaryThumbnailStyled>
      {img && !hasFailed(img) ? (
        <img
          src={formatMedia(img)}
          alt=''
          className='fs-mask'
          onError={() => markFailed(img)}
        />
      ) : (
        <IconImage size={20} color='darkGrey' aria-hidden />
      )}
    </ConversationOrderSummaryThumbnailStyled>
  )
}
